// utils/dateUtils.js

/**
 * تابع کمکی برای برگرداندن تاریخ شمسی امروز.
 *
 * 💡 نکته: در یک پروژه واقعی، برای تاریخ دقیق شمسی باید از یک کتابخانه 
 * تخصصی (مانند moment-jalaali) استفاده شود. 
 * در اینجا از یک تابع محلی‌سازی ساده برای رفع خطای "Module not found" استفاده شده است.
 */
export function getCurrentPersianDate() {
    // تنظیمات برای نمایش روز هفته، سال، ماه و روز به زبان فارسی
    const options = { 
        weekday: 'long', 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
    };
    
    // استفاده از 'fa-IR' برای نمایش تاریخ شمسی (در مرورگرهایی که پشتیبانی می‌کنند)
    const dateString = new Date().toLocaleDateString('fa-IR', options);
    
    return dateString;
}

// 💡 این فایل به کامپوننت ProfileHeader ایمپورت می‌شود.
// import { getCurrentPersianDate } from '../../utils/dateUtils';